import { createAction, props } from "@ngrx/store";
import { AuthorizeRequestType } from "../models/authorize-request";

export const authorize = createAction(
  '[Authorize] Retrieve Firm/User access functions',
  props<{ authorizeRequest: AuthorizeRequestType[] }>()
);

export const authorizeSuccess = createAction(
  '[Authorize] Call to Authorize successful',
  props<{ accessFunctions: {[key: string]: boolean} }>()
);

export const authorizeFailed = createAction(
  '[Authorize] Call to Authorize failed',
  props<{ errorMessage: string, accessFunctions: {[key: string]: boolean} }>()
);